import { render, staticRenderFns } from "./review.vue?vue&type=template&id=7fbe4c3a&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=7fbe4c3a&scoped=true&lang=css&"
import style1 from "./review.vue?vue&type=style&index=1&id=7fbe4c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe4c3a",
  null
  
)

export default component.exports